module.exports = require('./helpers/bundle-url').getBundleURL('AyoAQ') + "logo.c51670a8.svg";